import { gql } from '@apollo/client'
import {
  REPORT_FIELDS,
  REQUIRED_REPORT_FIELDS,
  ADMIN_REPORT_FIELDS,
} from '../fragments/report'

const GET_REPORTS = gql`
  ${REQUIRED_REPORT_FIELDS}
  query Reports {
    reports {
      ...RequiredReportFields
    }
  }
`

const GET_REPORTS_BY_DATE = gql`
  ${REPORT_FIELDS}
  query ReportsByDate($date: Date!, $reportType: ReportTypes!) {
    reportsByDate(date: $date, reportType: $reportType) {
      ...ReportFields
    }
  }
`

const GET_ADMIN_REPORTS = gql`
  ${ADMIN_REPORT_FIELDS}
  query AdminReports {
    adminReports {
      ...AdminReportFields
    }
  }
`

export { GET_REPORTS, GET_REPORTS_BY_DATE, GET_ADMIN_REPORTS }
